<cdss-patient-detail-header
    [patientId]="patientId"
    (goBack)="goBack()"
    (patientLoaded)="onPatientLoaded($event)">
</cdss-patient-detail-header>

<div class="daily-panel position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>

    <!-- Header -->
    <div class="panel-header">
        <div class="panel-header__title-row">
            <h2 class="panel-title">Daily Summary</h2>
            <cdss-daily-patient-carer-toggle
                *ngIf="showPatientCarerToggle"
                active="carer"
                (select)="onPatientCarerToggleSelect($event)">
            </cdss-daily-patient-carer-toggle>
        </div>
        <!-- Day navigation (v2 design: no adherence donut — removed per OQ-P1/OQ-P3) -->
        <div class="day-nav-metrics-row" *ngIf="date">
            <div class="day-nav-side">
                <button class="day-nav-arrow" (click)="navigateToPrevDay()" title="Previous day">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <span class="day-nav-label">{{ date | date:'EEEE d MMM' }}</span>
                <button
                    class="day-nav-arrow"
                    (click)="navigateToNextDay()"
                    [disabled]="isToday"
                    [class.disabled]="isToday"
                    title="Next day">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Main content: Daily check-in card / Chapter progress / Behaviour log only -->
    <ng-container *ngIf="!loading && (summary || noData)">

        <!-- No statistics for this day: same layout, every section disabled (UNIVAPLAT-3259).
             The status line stays outside the inert block so assistive tech still announces it. -->
        <p class="no-data-status" role="status" *ngIf="noData">No data recorded for this day.</p>
        <div class="main-columns" [class.main-columns--disabled]="noData" [attr.inert]="noData ? '' : null">

            <!-- LEFT: Daily check-ins (carer variant — never renders the patient-only
                 sleep-factor pills or contributing-factor chips) + Observed behaviours
                 (same column width) -->
            <div class="col-left">
                <div class="section-card mb-3">
                    <h3 class="section-title"><i class="bi bi-clipboard me-2"></i>Daily check-in</h3>
                    <cdss-daily-checkin-card
                        [checkins]="dailyCheckins"
                        variant="carer">
                    </cdss-daily-checkin-card>
                </div>

                <!-- Behaviour log — carer variant renders the "Observed behaviours" header;
                     an empty array is the positive "None today" state, so always rendered -->
                <div class="section-card">
                    <cdss-daily-behaviour-panel
                        [behaviours]="behaviours"
                        variant="carer">
                    </cdss-daily-behaviour-panel>
                </div>
            </div>

            <!-- RIGHT: Chapter progress -->
            <div class="col-right">

                <!-- Chapter progress — same weekly-scoped chapters array as the patient view (OQ-P2) -->
                <div class="section-card">
                    <h3 class="section-title"><i class="bi bi-book me-2"></i>Chapter progress</h3>
                    <cdss-weekly-chapter-list
                        [chapters]="chapterListItems"
                        [noDataText]="noData ? 'No chapter data for this day.' : null">
                    </cdss-weekly-chapter-list>
                </div>

            </div>

        </div>

    </ng-container>
</div>
